<template>
  <div>
    <TheProfileWidget v-if="user" force-open />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TheProfileWidget from "@/components/TheProfileWidget.vue";

export default {
  name: "ProfileView",
  components: {
    TheProfileWidget,
  },
  watch: {
    "$store.state.user": function (o, n) {
      if (n) this.$router.push("/");
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    if (!this.user) {
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped></style>
